
<div class="card-collection-quantity">
  <div
    v-for="(item, i) in individualCards"
    :key="i"
    class="item"
  >
    <align class="header" justify="space-between">
      <span class="number">Card #{{ i + 1 }}</span>
      <icon-button class="trash" icon="delete_outline" @click="removeCard(i)" />
    </align>

    <div class="input-group">
      <currency-input
        v-model="individualCards[i].investment"
        label="Purchase Price"
        placeholder="1000"
        required
      />

      <date-input
        v-model="individualCards[i].datePurchased"
        label="Purchase Date"
      />
    </div>

    <div>
      <checkbox
        v-model="individualCards[i].sold"
        label="Mark as sold"
      />
    </div>

    <div v-show="individualCards[i].sold" class="input-group">
      <currency-input
        v-model="individualCards[i].priceSold"
        placeholder="2000"
        label="Sale Price"
        :required="individualCards[i].sold"
      />

      <date-input
        v-model="individualCards[i].dateSold"
        label="Sale Date"
      />
    </div>

    <div>
      <checkbox
        v-model="individualCards[i].ownsPercentage"
        label="Setup fractional ownership"
      />
    </div>


    <div v-show="individualCards[i].ownsPercentage">
      <text-input
        v-model="individualCards[i].ownershipPercentage"
        type="number"
        label="What percentage do you own?"
        placeholder="50"
      />
    </div>
  </div>

  <add-link
    v-if="individualCards && individualCards.length < limit"
    class="icon-link"
    @click="addCard"
  >
    Add another card
  </add-link>
</div>
